import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth, loginWithEmail, logout as firebaseLogout } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

// Criação do contexto
const AuthContext = createContext(null);

// Hook personalizado para usar o contexto
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

// Provedor do contexto
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Efeito para monitorar mudanças no estado de autenticação
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  // Função para fazer login
  const login = async (email, password) => {
    try {
      setError(null);
      const result = await loginWithEmail(email, password);
      
      if (!result.success) {
        setError(result.error || 'Falha ao fazer login');
        return false;
      }
      
      return true;
    } catch (err) {
      setError(err.message || 'Erro desconhecido ao fazer login');
      return false;
    }
  };

  // Função para fazer logout
  const logout = async () => {
    try {
      setError(null);
      await firebaseLogout();
      return true;
    } catch (err) {
      setError(err.message || 'Erro ao fazer logout');
      return false;
    }
  };

  // Verificar se o usuário está autenticado
  const isAuthenticated = currentUser !== null;

  // Objeto com valores e funções a serem disponibilizadas pelo contexto
  const value = {
    currentUser,
    loading,
    error,
    login,
    logout,
    isAuthenticated
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 